import { useState, useEffect } from 'react';

const BERLIN = new Intl.DateTimeFormat('sv-SE', {
  timeZone: 'Europe/Berlin',
  year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
});

// ISO timestamp → "2026-10-09 16:42" in Europe/Berlin time; null if invalid
export function berlinDateTime(iso) {
  if (!iso || iso === 'unknown') return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : BERLIN.format(d).replace(',', '');
}

// Server build time in Berlin time. Older version.json files only have
// build_date ("YYYY-MM-DD HH:MM", written in UTC).
export function buildTimeBerlin(v) {
  if (!v) return null;
  if (v.build_time) return berlinDateTime(v.build_time);
  if (v.build_date && v.build_date !== 'unknown') return berlinDateTime(`${v.build_date.replace(' ', 'T')}:00Z`);
  return null;
}

// "v 2026-10-09 16:42 · d6ca3d5"; date only when the commit time is missing
export function versionLabel(v) {
  if (!v?.commit || v.commit === 'unknown') return null;
  const when = berlinDateTime(v.commit_time)
    || (v.commit_date && v.commit_date !== 'unknown' ? v.commit_date.slice(0, 10) : null);
  return when ? `v ${when} · ${v.commit}` : null;
}

// { label, built } — label null when unknown, undefined while loading
export default function useAppVersion() {
  const [info, setInfo] = useState({ label: undefined, built: null });

  useEffect(() => {
    fetch('/version.json')
      .then((r) => r.json())
      .then((d) => setInfo({ label: versionLabel(d), built: buildTimeBerlin(d) }))
      .catch(() => setInfo({ label: null, built: null }));
  }, []);

  return info;
}
